<template>
  <div class="card" v-show="isSection('create-date')">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>履歴書の作成日を入力</h2>
        <p>実際に書類を持参する日、または郵送する日を選びましょう</p>
      </div>
      <div class="card-content">
        <div class="edit-form-list">
          <div class="create-date-action">
            <div class="action-item">
              <el-button
                class="button-block"
                :disabled="isTodaySelected"
                @click="setToday"
                >今日の日付を入力</el-button
              >
            </div>
            <div class="action-item">
              <el-button
                class="button-block"
                :disabled="isTomorrowSelected"
                @click="setTomorrow"
                >明日の日付を入力</el-button
              >
            </div>
            <div class="action-item">
              <el-date-picker
                v-model="formatData.createDate"
                type="date"
                :clearable="false"
                placeholder="選択してください"
                :format="'yyyy年M月d日'"
              />
            </div>
          </div>
        </div>
        <br />
        <div class="aiInterview_date" v-if="showBanner">
          <a
            href="/yagiprimequickemail/info"
            class="aiInterview_lead"
            target="_blank"
            id="quickemailbnr_date_btn"
          >
            <img src="/static/mypage/quickemailbnr.jpg" alt="メール便" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { isCardSectionActive } from '@/utils/format-edit/cardSections'

const props = withDefaults(
  defineProps<{
    currentCardId?: string
    formatId?: string
    showQuickEmailBanner?: boolean
  }>(),
  {
    showQuickEmailBanner: true
  }
)

type DateFormLib = {
  dateWithoutTime: (date: Date | string | null | undefined) => number | string
  getToday: () => Date
  getTommorow: () => Date
}

type GlobalVarWithPayments = {
  in_app_payments?: boolean
}

const { formLib: formLibRaw, globalVar } = useHostServices()
const formLib = formLibRaw as typeof formLibRaw & DateFormLib
const formatData = useRirekishoFormatData()

/**
 * 作成日は書式によって独立ステップではなく確認画面に置かれる
 * （カード定義の `sections`）。
 */
const isSection = (section: string) =>
  isCardSectionActive(props.formatId, props.currentCardId, section)

const showBanner = computed(
  () =>
    props.showQuickEmailBanner &&
    !!(globalVar as typeof globalVar & GlobalVarWithPayments).in_app_payments
)

const isTodaySelected = computed(
  () =>
    formLib.dateWithoutTime(formatData.createDate) ===
    formLib.dateWithoutTime(formLib.getToday())
)

const isTomorrowSelected = computed(
  () =>
    formLib.dateWithoutTime(formatData.createDate) ===
    formLib.dateWithoutTime(formLib.getTommorow())
)

function setToday() {
  formatData.createDate = formLib.getToday()
}

function setTomorrow() {
  formatData.createDate = formLib.getTommorow()
}
</script>

<style lang="scss" scoped>
.aiInterview_date {
  text-align: center;

  .aiInterview_lead {
    img {
      width: 350px;
      border-radius: 10px;

      @media screen and (width <= 599px) {
        width: 100%;
      }
    }
  }
}
</style>
